export default class Subject {
	constructor(state) {
		this.state = state;
		this.observers = [];
	}

	getState() {
		return this.state;
	}

	setState(state) {
		this.state = state;

		this.notifyObservers(this.state);
	}

	registerObserver(observer) {
		this.observers.push(observer);
	}

	unregisterObserver(observer) {
		this.observers = this.observers.filter(obs => obs !== observer);
	}

	notifyObservers(data) {
		this.observers.forEach(observer => observer.notify(data));
	}
}
